var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gallery',{attrs:{"images":_vm.propsFile,"index":_vm.index},on:{"close":function($event){_vm.index = null}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }